import 'antd-mobile/dist/antd-mobile.css';
import qs from 'qs'
import axios from 'axios'


var userRequest = {};
var userApi = {
  settingInfo:'/setting/info',
  userInfo: '/userv2/info',
  courseList:'/person/course-api/get-course-list',  //获取课程列表
  courseListFinished: '/course-api/course/get-course-record', // 获取完成课程的列表
  courseDetail:'/person/course-api/get-course-detail', //获取课程详情
  getCourseExcellent:'/person/course-api/get-course-excellent', //优秀作品
  getSubjectInfo:'/person/course-api/get-course-subject-info',//获取章节信息
  courseCategory:'/person/course-api/get-category-list', //课程分类
  getQuestionList:'/person/course-api/get-question-list',//获取问答列表
  addQuestion:'/person/course-api/add-question',//添加问题
  upload:'/person/course-api/upload',//上传文件
  addReport:'/person/course-api/add-my-sub-report',//添加章节报告
  getTopicLists:'/v1/topic-chat/get-topic-lists',//话题
  addTopicChat:'/v1/topic-chat/add-chat',//新建对话
  getTopicChatLists:'/v1/topic-chat/get-topic-chat-lists',//话题及回复列表
  addchat:'/topic-chat/add-chat-outer',//添加信息content  对话内容 user_id course_id
  getchat:'/topic-chat/get-chat-lists-outer', //获取列表
  getLiveInfo:'/person/live-api/living-course-api',//获取直播课信息
  getRecord:'/person/course-api/get-record',//查询学习(收藏)记录
  addRecord:'/person/course-api/add-record',//添加学习(收藏)记录
  delRecord:'/person/course-api/del-record',//删除
  getLearned:'/person/course-api/get-learned',//查询学过的章节
  getMySubRecord:'/person/course-api/get-my-sub-report',//获取我的章节报告
  subjectMembers: '/sourcepack/subject-members', // 获取学习时长
  coursePermission: '/sourcepack/permission',
  getNotesList: '/course-api/course/get-course-note-list', // 获取笔记列表
  addNotes: '/course-api/course/create-course-note', // 添加笔记
  getCourseWatch:'/course-api/course/click/',//直播
  addLiveTopic:'/person/live-api/add-topic',//发起话题
  checkChat:'/person/live-api/check-chat',//检查是否可以发送评论
  userinfo:'/person/info',//用户信息,
  recordCreate: '/course-api/course/record-create', // 初始化 播放时长统计
  // recordCreate: '/person/course-api/course/record-create', // 初始化 播放时长统计
  // firstIdentify: 'http://api.msa.chinamcloud.cn/userapi/v1/tencent/faceid/getloginurl',
  // firstIdentifyCallback: 'http://api.msa.chinamcloud.com/userapi/v1/tencent/faceid/checkfaceid',
  // secondIdentify: '/course-api/record-auth/auth',
  // secondIdentifyCallback: '/course-api/record-auth/check-face',
  // rentConfig: 'http://tenant.msa.chinamcloud.com/v1/tenantauth',
  // courseListFinishedLock: 'http://sourcepack.msa.chinamcloud.com/course/subject-auth/', //获取目录课程是否解锁
  firstIdentify: '/userv2/tencent/faceid/getloginurl',
  firstIdentifyCallback: '/userv2/tencent/faceid/checkfaceid',
  secondIdentify: '/course-api/record-auth/auth',
  secondIdentifyCallback: '/course-api/record-auth/check-face',
  rentConfig: '/tenantauth',
  courseListFinishedLock: '/sourcepack/subject-auth/'
};


/**
 * 封装统一的ajax请求，统一拦截请求，对不同的请求状态封装
 * 通常说, ajax 请求错误有两种, 一种是网络问题或者代码问题所造成的 400, 500错误等,需要checkStatus方法拦截
 * 另外一种是请求参数后端通不过验证, 由后端抛出的错误，需要checkCode拦截处理
 * 第二种根据不同的后端框架或者程序猿又可以分成两种, 一种是直接返回 json, 用一个 特别的 code 来区别正常请求返回的数据, 如:
 */


/**
 * axios请求拦截器
 * @param {object} config axios请求配置对象
 * @return {object} 请求成功或失败时返回的配置对象或者promise error对象
 **/

axios.interceptors.request.use(config => {
//  message.destroy();
//  message.config({
//   top: '40%',
//   duration: 2,
//   maxCount: 3,
// });

//   message.loading('正在加载',0)


  return config
}, error => {
  return Promise.reject(error)
})

/**
 * axios 响应拦截器
 * @param {object} response 从服务端响应的数据对象或者error对象
 * @return {object} 响应成功或失败时返回的响应对象或者promise error对象
 **/
axios.interceptors.response.use(response => {

   // message.destroy()
  return response
}, error => {
  return Promise.resolve(error)
})

/**
 * 请求发出后检查返回的状态码,统一捕获正确和错误的状态码，正确就直接返回response,错误就自定义一个返回对象
 * @param {object} response 响应对象
 * @return {object} 响应正常就返回响应数据否则返回错误信息
 **/
function checkStatus (response) {
  // 如果状态码正常就直接返回数据,这里的状态码是htttp响应状态码有400，500等，不是后端自定义的状态码
  if (response && ((response.status === 200 || response.status === 304 || response.status === 400))) {
    return response.data // 直接返回http response响应的data,此data会后端返回的数据数据对象，包含后端自定义的code,message,data属性
  }
  return { // 自定义网络异常对象
    code: '404',
    message: '网络异常'
  }
}

/**
 * 检查完状态码后需要检查后如果成功了就需要检查后端的状态码处理网络正常时后台语言返回的响应
 * @param {object} res 是后台返回的对象或者自定义的网络异常对象，不是http 响应对象
 * @return {object} 返回后台传过来的数据对象，包含code,message,data等属性，
 **/
// function checkCode (res) {
//   // 如果状态码正常就直接返回数据
//   console.log(res)
//   if (res.code === -404) { // 这里包括网络异常，服务器异常等这种异常跟业务无关，直接弹窗警告
//     alert(res.message)
//     return {code: '', message: '网络错误'}
//   } else { // 除了上面的异常就剩下后端自己返回的状态code了这个直接返回出去供调用时根据不同的code做不同的处理
//     return res
//   }
// }


 userRequest.post=function(url, data) {
    return axios({
      method: 'post',
      baseURL: process.env.BASE_URL,
      url: url,
      data: qs.stringify(data),
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/x-www-form-urlencoded',
      },
      timeout: 10000
    }).then((res) => {
      return checkStatus(res)
    })
  }

   userRequest.postRequest=function(url, data, opt) {
    return axios({
      method: 'post',
      baseURL: process.env.BASE_URL,
      url,
      data,
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',

      },
      timeout: 10000,
      ...(opt||{})
    }).then((res) => {
      return checkStatus(res)
    })
  }


  userRequest.get=function(url, params) {

    const getCookie = (name) => {
      let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
      if (arr = document.cookie.match(reg)) return unescape(arr[2])
      else return null
    }

    let token = getCookie('_token')
    let pattern=/{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/
    token = pattern.exec(decodeURIComponent(token))
    token = token?`${token[1]}`: ''

    const tenantId = localStorage.getItem('tenant_code')||95
    return axios({
      method: 'get',
      baseURL: process.env.BASE_URL,
      url:url,
      params,
      timeout: 10000,
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
         'Authorization': `bearer ${token}`,
         'Tenant-Id': tenantId
      },
        paramsSerializer:function(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
        }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    )
  }


export default userRequest;
export {
    userApi
};

// // http request 请求拦截器，有token值则配置上token值
// axios.interceptors.request.use(
//     config => {
//         if(token) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
//             config.headers.Authorization = token;
//         }
//         return config;
//     },
//     err => {
//         return Promise.reject(err);
//     });

// // http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
// axios.interceptors.response.use(
//     response => {
//         return response;
//     },
//     error => {
//         if(error.response) {
//             switch(error.response.status) {
//                 case 401:
//                     // 这里写清除token的代码
//                     router.replace({
//                         path: 'login',
//                         query: {
//                             redirect: router.currentRoute.fullPath
//                         } //登录成功后跳入浏览的当前页面
//                     })
//             }
//         }
//         return Promise.reject(error.response.data)
//     });
